import script from "./email.vue?vue&type=script&lang=ts&setup=true"
export * from "./email.vue?vue&type=script&lang=ts&setup=true"

import "./email.vue?vue&type=style&index=0&id=da4dad16&scoped=true&lang=css"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da4dad16"]])

export default __exports__